/* ==========================================================================
   Bilash Haat - theme JavaScript
   Vanilla ES2020. No build step, no dependencies.
   Relies on window.theme (routes + strings) declared in layout/theme.liquid.
   ========================================================================== */

(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};

  /* ------------------------------------------------------------------------
     Helpers
     ------------------------------------------------------------------------ */

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function on(element, event, selector, handler) {
    element.addEventListener(event, function (e) {
      var target = e.target.closest(selector);
      if (target && element.contains(target)) handler(e, target);
    });
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      var context = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  /* ------------------------------------------------------------------------
     Focus trap for drawers
     ------------------------------------------------------------------------ */

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var trapHandler = null;

  function trapFocus(container) {
    releaseFocus();
    var focusable = $$(FOCUSABLE, container).filter(function (el) {
      return el.offsetParent !== null;
    });
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    trapHandler = function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    container.addEventListener('keydown', trapHandler);
    container._trapHandler = trapHandler;
    first.focus();
  }

  function releaseFocus() {
    $$('.drawer').forEach(function (drawer) {
      if (drawer._trapHandler) {
        drawer.removeEventListener('keydown', drawer._trapHandler);
        drawer._trapHandler = null;
      }
    });
  }

  /* ------------------------------------------------------------------------
     Drawers (cart, mobile nav)
     ------------------------------------------------------------------------ */

  var lastFocusedElement = null;

  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    lastFocusedElement = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    var overlay = $('.overlay');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('drawer-open');
    setTimeout(function () {
      trapFocus(drawer);
    }, 60);
  }

  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    });
    var overlay = $('.overlay');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    releaseFocus();
    if (lastFocusedElement) {
      lastFocusedElement.focus();
      lastFocusedElement = null;
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('overlay')) {
      e.preventDefault();
      closeDrawers();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawers();
      closePredictiveSearch();
    }
  });

  /* ------------------------------------------------------------------------
     Cart
     ------------------------------------------------------------------------ */

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  // Re-render the cart drawer and the cart page from the server so that
  // discounts, totals and free-shipping thresholds stay authoritative.
  function refreshCartSections() {
    var sections = ['cart-drawer'];
    if ($('#MainCart')) sections.push('main-cart');

    return fetch(routes.cart_url + '?sections=' + sections.join(','))
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        sections.forEach(function (name) {
          if (!data[name]) return;
          var parsed = new DOMParser().parseFromString(data[name], 'text/html');
          var incoming = parsed.querySelector('[data-section-content="' + name + '"]');
          var current = $('[data-section-content="' + name + '"]');
          if (incoming && current) {
            current.innerHTML = incoming.innerHTML;
            var count = incoming.getAttribute('data-item-count');
            if (count !== null) updateCartCount(parseInt(count, 10));
          }
        });
      });
  }

  function setLoading(button, isLoading) {
    if (!button) return;
    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
  }

  // The Ajax Cart API lives at the .js endpoints. The bare /cart/add can answer
  // with a redirect to the cart page, which then fails to parse as JSON.
  function cartApi(url) {
    return url + '.js';
  }

  function addToCart(formOrData, button) {
    var body;
    var headers = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

    if (formOrData instanceof HTMLFormElement) {
      body = new FormData(formOrData);
    } else {
      body = new FormData();
      body.append('id', formOrData.id);
      body.append('quantity', formOrData.quantity || 1);
    }

    setLoading(button, true);

    return fetchJSON(cartApi(routes.cart_add_url), { method: 'POST', headers: headers, body: body })
      .then(function () {
        // The item is in the cart now. If the drawer can't be refreshed, show
        // the cart page rather than an error for an add that worked.
        return refreshCartSections().then(
          function () {
            if (theme.cartType === 'drawer' && document.getElementById('CartDrawer')) {
              openDrawer('CartDrawer');
            } else {
              window.location.href = routes.cart_url;
            }
          },
          function () {
            window.location.href = routes.cart_url;
          }
        );
      })
      .catch(function (error) {
        showCartError(error && error.description ? error.description : theme.strings.cartError);
      })
      .finally(function () {
        setLoading(button, false);
      });
  }

  function showCartError(message) {
    var target = $('[data-cart-error]');
    if (target) {
      target.textContent = message;
      target.hidden = false;
      setTimeout(function () {
        target.hidden = true;
      }, 6000);
    } else {
      alert(message);
    }
  }

  function changeCartLine(key, quantity, button) {
    setLoading(button, true);
    return fetchJSON(cartApi(routes.cart_change_url), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () {
        return refreshCartSections();
      })
      .catch(function (error) {
        showCartError(error && error.description ? error.description : theme.strings.cartError);
      })
      .finally(function () {
        setLoading(button, false);
      });
  }

  // Product form submissions (product page + quick add)
  on(document, 'submit', 'form[data-product-form]', function (e, form) {
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    addToCart(form, button);
  });

  // Quick add straight from a product card
  on(document, 'click', '[data-quick-add]', function (e, button) {
    e.preventDefault();
    e.stopPropagation();
    addToCart({ id: button.getAttribute('data-variant-id'), quantity: 1 }, button);
  });

  // Cart line quantity + removal
  on(document, 'click', '[data-cart-remove]', function (e, button) {
    e.preventDefault();
    changeCartLine(button.getAttribute('data-line-key'), 0, button);
  });

  on(document, 'change', '[data-cart-quantity]', function (e, input) {
    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity) || quantity < 0) quantity = 1;
    changeCartLine(input.getAttribute('data-line-key'), quantity, input);
  });

  // Order note, saved on blur
  on(document, 'change', '[data-cart-note]', function (e, field) {
    fetch(cartApi(routes.cart_update_url), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ note: field.value })
    });
  });

  /* ------------------------------------------------------------------------
     Quantity steppers
     ------------------------------------------------------------------------ */

  on(document, 'click', '[data-quantity-button]', function (e, button) {
    e.preventDefault();
    var wrapper = button.closest('.quantity');
    var input = $('input', wrapper);
    if (!input) return;

    var step = button.getAttribute('data-quantity-button') === 'increase' ? 1 : -1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : Infinity;
    var value = (parseInt(input.value, 10) || min) + step;

    input.value = Math.min(Math.max(value, min), max);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------------
     Variant picker
     ------------------------------------------------------------------------ */

  function initVariantPicker(container) {
    var dataEl = $('[data-variant-json]', container);
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    var idInput = $('[data-variant-id-input]', container);
    var priceTarget = $('[data-price-target]', container);
    var submitButton = $('[data-add-button]', container);
    var skuTarget = $('[data-sku-target]', container);
    var inventoryTarget = $('[data-inventory-target]', container);

    function selectedOptions() {
      return $$('[data-option-selector]', container).map(function (input) {
        if (input.type === 'radio') return null;
        return input.value;
      });
    }

    function currentOptions() {
      var options = [];
      $$('[data-option-index]', container).forEach(function (group) {
        var index = parseInt(group.getAttribute('data-option-index'), 10);
        var checked = $('input:checked', group) || $('select', group);
        if (checked) options[index] = checked.value;
      });
      return options;
    }

    function findVariant(options) {
      return (
        variants.filter(function (variant) {
          return options.every(function (value, index) {
            return variant.options[index] === value;
          });
        })[0] || null
      );
    }

    function update() {
      var variant = findVariant(currentOptions());

      if (!variant) {
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = theme.strings.unavailable;
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      // Keep the URL shareable without reloading the page.
      if (variant.url_param) {
        window.history.replaceState({}, '', variant.url_param);
      }

      if (priceTarget && variant.price_html) priceTarget.innerHTML = variant.price_html;
      if (skuTarget) skuTarget.textContent = variant.sku || '';

      if (submitButton) {
        submitButton.disabled = !variant.available;
        submitButton.textContent = variant.available
          ? theme.strings.addToCart
          : theme.strings.soldOut;
      }

      if (inventoryTarget && variant.inventory_html !== undefined) {
        inventoryTarget.innerHTML = variant.inventory_html;
      }

      // Jump the gallery to the image for this variant.
      if (variant.featured_media_id) {
        var thumb = $('[data-media-id="' + variant.featured_media_id + '"]', container.closest('.product') || document);
        if (thumb) thumb.click();
      }
    }

    container.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });
  }

  /* ------------------------------------------------------------------------
     Product gallery
     ------------------------------------------------------------------------ */

  on(document, 'click', '[data-media-id]', function (e, thumb) {
    e.preventDefault();
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;

    var main = $('[data-gallery-main]', gallery);
    var full = thumb.getAttribute('data-media-full');
    var alt = thumb.getAttribute('data-media-alt') || '';

    if (main && full) {
      var img = main.querySelector('img');
      if (img) {
        img.src = full;
        img.srcset = thumb.getAttribute('data-media-srcset') || '';
        img.alt = alt;
      }
    }

    $$('[data-media-id]', gallery).forEach(function (el) {
      el.classList.toggle('is-active', el === thumb);
      el.setAttribute('aria-current', el === thumb ? 'true' : 'false');
    });
  });

  /* ------------------------------------------------------------------------
     Product detail links

     Opens the matching row in the panel below the product and scrolls to it.
     Falls back to a plain anchor jump when JavaScript is unavailable, since
     the links are real hrefs.
     ------------------------------------------------------------------------ */

  on(document, 'click', '[data-open-details]', function (e, link) {
    var target = document.getElementById(link.getAttribute('data-open-details'));
    if (!target) return;

    e.preventDefault();
    target.open = true;

    // Clear the tint from a previous jump so it can play again.
    target.classList.remove('is-flashed');
    // Reading offsetWidth restarts the animation.
    void target.offsetWidth;
    target.classList.add('is-flashed');

    var header = $('[data-header]');
    var offset = header ? header.offsetHeight + 16 : 16;
    var top = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({ top: top, behavior: 'smooth' });

    // Move focus for keyboard and screen reader users.
    var summary = target.querySelector('summary');
    if (summary) {
      summary.setAttribute('tabindex', '-1');
      setTimeout(function () {
        summary.focus({ preventScroll: true });
      }, 400);
    }
  });

  /* ------------------------------------------------------------------------
     Predictive search
     ------------------------------------------------------------------------ */

  function closePredictiveSearch() {
    $$('[data-predictive-results]').forEach(function (el) {
      el.hidden = true;
    });
  }

  var runSearch = debounce(function (input) {
    var wrapper = input.closest('[data-predictive-search]');
    if (!wrapper) return;
    var results = $('[data-predictive-results]', wrapper);
    if (!results) return;

    var term = input.value.trim();
    if (term.length < 2) {
      results.hidden = true;
      return;
    }

    var url =
      routes.predictive_search_url +
      '?q=' +
      encodeURIComponent(term) +
      '&resources[type]=product,collection,page' +
      '&resources[limit]=6' +
      '&section_id=predictive-search';

    fetch(url)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var content = parsed.querySelector('[data-predictive-content]');
        results.innerHTML = content ? content.innerHTML : '';
        results.hidden = false;
      })
      .catch(function () {
        results.hidden = true;
      });
  }, 250);

  on(document, 'input', '[data-predictive-input]', function (e, input) {
    runSearch(input);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-predictive-search]')) closePredictiveSearch();
  });

  /* ------------------------------------------------------------------------
     Custom select

     Native option lists are rendered by the operating system and cannot be
     styled. The real <select> stays in the DOM and remains the source of
     truth; this drives a styled listbox and writes the choice back to it,
     firing `change` so the facet form still submits.
     ------------------------------------------------------------------------ */

  function closeCustomSelects(except) {
    $$('[data-custom-select]').forEach(function (root) {
      if (root === except) return;
      var list = $('[data-custom-select-list]', root);
      var toggle = $('[data-custom-select-toggle]', root);
      if (list) list.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function initCustomSelects(scope) {
    $$('[data-custom-select]', scope || document).forEach(function (root) {
      if (root._customSelect) return;
      root._customSelect = true;

      var native = $('select', root);
      var toggle = $('[data-custom-select-toggle]', root);
      var list = $('[data-custom-select-list]', root);
      var label = $('[data-custom-select-label]', root);
      if (!native || !toggle || !list) return;

      var options = $$('[role="option"]', list);
      var activeIndex = Math.max(
        options.findIndex(function (o) {
          return o.getAttribute('aria-selected') === 'true';
        }),
        0
      );

      function open() {
        closeCustomSelects(root);
        list.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        highlight(activeIndex);
        options[activeIndex].focus();
      }

      function close(refocus) {
        list.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        if (refocus) toggle.focus();
      }

      function highlight(index) {
        activeIndex = (index + options.length) % options.length;
        options.forEach(function (option, i) {
          option.classList.toggle('is-active', i === activeIndex);
        });
        options[activeIndex].focus();
      }

      function choose(option) {
        native.value = option.getAttribute('data-value');
        if (label) label.textContent = option.querySelector('span').textContent.trim();

        options.forEach(function (other) {
          var selected = other === option;
          other.setAttribute('aria-selected', selected ? 'true' : 'false');
          other.classList.toggle('is-selected', selected);
        });

        close(true);
        // Let the facet form's change handler take it from here.
        native.dispatchEvent(new Event('change', { bubbles: true }));
      }

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (list.hidden) {
          open();
        } else {
          close(true);
        }
      });

      options.forEach(function (option, index) {
        option.addEventListener('click', function () {
          choose(option);
        });
        option.addEventListener('mouseenter', function () {
          activeIndex = index;
          options.forEach(function (other, i) {
            other.classList.toggle('is-active', i === activeIndex);
          });
        });
      });

      root.addEventListener('keydown', function (e) {
        if (list.hidden) {
          if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            open();
          }
          return;
        }

        switch (e.key) {
          case 'ArrowDown':
            e.preventDefault();
            highlight(activeIndex + 1);
            break;
          case 'ArrowUp':
            e.preventDefault();
            highlight(activeIndex - 1);
            break;
          case 'Home':
            e.preventDefault();
            highlight(0);
            break;
          case 'End':
            e.preventDefault();
            highlight(options.length - 1);
            break;
          case 'Enter':
          case ' ':
            e.preventDefault();
            choose(options[activeIndex]);
            break;
          case 'Escape':
            e.preventDefault();
            close(true);
            break;
          case 'Tab':
            close(false);
            break;
        }
      });
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-custom-select]')) closeCustomSelects();
  });

  /* ------------------------------------------------------------------------
     Facets - auto submit the filter form
     ------------------------------------------------------------------------ */

  on(document, 'change', '[data-facet-form] input, [data-facet-form] select', function (e, input) {
    var form = input.closest('[data-facet-form]');
    if (form) form.submit();
  });

  /* ------------------------------------------------------------------------
     3D tilt cards

     Rotates a card toward the cursor and moves the hover sheen with it.
     Pointer-driven, so it is skipped entirely on touch devices and when the
     visitor has asked for reduced motion.
     ------------------------------------------------------------------------ */

  function initTiltCards(scope) {
    if (!window.matchMedia) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    $$('[data-tilt]', scope || document).forEach(function (card) {
      if (card._tilt) return;
      card._tilt = true;

      var max = parseFloat(card.getAttribute('data-tilt-max')) || 8;
      var frame = null;

      function apply(event) {
        frame = null;

        var rect = card.getBoundingClientRect();
        if (!rect.width || !rect.height) return;

        var px = (event.clientX - rect.left) / rect.width;
        var py = (event.clientY - rect.top) / rect.height;

        // Clamp so a fast pointer leaving the card cannot overshoot.
        px = Math.min(Math.max(px, 0), 1);
        py = Math.min(Math.max(py, 0), 1);

        card.style.setProperty('--tilt-y', ((px - 0.5) * 2 * max).toFixed(2) + 'deg');
        card.style.setProperty('--tilt-x', (-(py - 0.5) * 2 * max).toFixed(2) + 'deg');
        card.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
        card.style.setProperty('--my', (py * 100).toFixed(1) + '%');
      }

      card.addEventListener('pointerenter', function () {
        card.classList.add('is-tilting');
      });

      card.addEventListener('pointermove', function (event) {
        if (frame) return;
        frame = window.requestAnimationFrame(function () {
          apply(event);
        });
      });

      card.addEventListener('pointerleave', function () {
        if (frame) {
          window.cancelAnimationFrame(frame);
          frame = null;
        }
        // Drop the class first so the reset eases back instead of snapping.
        card.classList.remove('is-tilting');
        card.style.setProperty('--tilt-x', '0deg');
        card.style.setProperty('--tilt-y', '0deg');
      });
    });
  }

  /* ------------------------------------------------------------------------
     Scroll-in animations
     ------------------------------------------------------------------------ */

  function initAnimations() {
    var items = $$('[data-animate]:not(.is-visible)');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -80px 0px' }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ------------------------------------------------------------------------
     Hero slideshow
     ------------------------------------------------------------------------ */

  /* Measures whatever sits above the hero (announcement bar + header) and
     feeds it to CSS, so a hero set to 100% ends exactly at the fold. */
  function setHeroOffset() {
    $$('[data-fit-below-header]').forEach(function (hero) {
      var top = hero.getBoundingClientRect().top + window.scrollY;

      // Only meaningful when the hero really is at the top of the page.
      if (top > 400) top = 0;

      hero.style.setProperty('--hero-offset', Math.round(top) + 'px');
    });
  }

  var debouncedHeroOffset = debounce(setHeroOffset, 150);

  function initSlideshows(scope) {
    setHeroOffset();

    $$('[data-slideshow]', scope || document).forEach(function (slideshow) {
      if (slideshow._initialised) return;
      slideshow._initialised = true;

      var slides = $$('[data-slide]', slideshow);
      var dots = $$('[data-slide-to]', slideshow);
      if (slides.length < 2) return;

      var index = 0;
      var timer = null;
      var autoplay = slideshow.getAttribute('data-autoplay') === 'true';
      var interval = parseInt(slideshow.getAttribute('data-interval'), 10) || 6000;

      function show(next) {
        index = (next + slides.length) % slides.length;

        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        dots.forEach(function (dot, i) {
          var active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      function start() {
        if (!autoplay) return;
        stop();
        timer = setInterval(function () {
          show(index + 1);
        }, interval);
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      // Restart the clock after any manual interaction.
      function goTo(next) {
        show(next);
        start();
      }

      var prev = $('[data-slide-prev]', slideshow);
      var next = $('[data-slide-next]', slideshow);

      if (prev) {
        prev.addEventListener('click', function () {
          goTo(index - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          goTo(index + 1);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.getAttribute('data-slide-to'), 10));
        });
      });

      slideshow.addEventListener('mouseenter', stop);
      slideshow.addEventListener('mouseleave', start);
      slideshow.addEventListener('focusin', stop);
      slideshow.addEventListener('focusout', start);

      // Pause while the tab is in the background.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });

      // Swipe on touch devices.
      var startX = null;
      slideshow.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].clientX;
          stop();
        },
        { passive: true }
      );

      slideshow.addEventListener(
        'touchend',
        function (e) {
          if (startX === null) return;
          var delta = e.changedTouches[0].clientX - startX;
          if (Math.abs(delta) > 50) show(delta < 0 ? index + 1 : index - 1);
          startX = null;
          start();
        },
        { passive: true }
      );

      show(0);
      start();
    });
  }

  // Scroll cue jumps to whatever section follows the hero.
  on(document, 'click', '[data-scroll-cue]', function (e, button) {
    e.preventDefault();

    var hero = button.closest('[data-slideshow]');
    var wrapper = hero ? hero.closest('.shopify-section') || hero : null;
    var target = wrapper ? wrapper.nextElementSibling : null;

    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (hero) {
      window.scrollTo({ top: hero.offsetHeight, behavior: 'smooth' });
    }
  });

  window.addEventListener('resize', debouncedHeroOffset);
  window.addEventListener('orientationchange', debouncedHeroOffset);

  /* ------------------------------------------------------------------------
     Policy pages: split one HTML blob into a card per section

     Policy bodies are authored in Shopify admin and arrive as a single run of
     headings, paragraphs and lists. This groups each heading with the content
     that follows it. Progressive enhancement: without it the page still reads
     correctly as one card.
     ------------------------------------------------------------------------ */

  /* Shopify renders /policies/* with its own markup, not a theme template, so
     the body is tagged here and then handed to the same card splitter. */
  function initShopifyPolicy() {
    var body = $('.shopify-policy__body');
    if (!body) return;

    // Shopify sometimes nests the content in its own .rte wrapper.
    var content = body.querySelector('.rte') || body;
    if (content.hasAttribute('data-split-into-cards')) return;

    content.setAttribute('data-split-into-cards', '');

    var container = $('.shopify-policy__container');
    if (container) container.classList.add('is-carded');
  }

  function isHeading(node) {
    return /^H[1-6]$/.test(node.tagName);
  }

  /* A paragraph whose entire content is bold, used as a heading. Common in
     policy text pasted from Word or Google Docs. */
  function isPseudoHeading(node) {
    if (node.tagName !== 'P') return false;

    var text = node.textContent.trim();
    if (!text || text.length > 80) return false;

    var meaningful = Array.prototype.filter.call(node.childNodes, function (child) {
      return child.nodeType !== 3 || child.textContent.trim() !== '';
    });

    return (
      meaningful.length === 1 &&
      /^(STRONG|B)$/.test(meaningful[0].tagName) &&
      meaningful[0].textContent.trim() === text
    );
  }

  /* Admin sometimes wraps the whole body in a single div. Descend past those
     so the headings we split on are actually direct children. */
  function unwrapSingleContainer(root) {
    var node = root;

    while (
      node.children.length === 1 &&
      /^(DIV|ARTICLE|SECTION|MAIN)$/.test(node.children[0].tagName)
    ) {
      node = node.children[0];
    }

    return node;
  }

  /* Swaps the original run of nodes for the built cards and hands the styling
     over to them. `target` is the element that carried the attribute, `root`
     the (possibly nested) element whose children were regrouped. */
  function finalise(target, root, fragment) {
    root.innerHTML = '';
    root.appendChild(fragment);

    root.classList.remove('content-card', 'rte');
    root.classList.add('policy-cards');

    // Drop the single-card styling from the outer wrapper too, or it draws a
    // second border around the whole grid.
    if (target !== root) target.classList.remove('content-card', 'rte');
  }

  function initPolicyCards(scope) {
    initShopifyPolicy();

    $$('[data-split-into-cards]', scope || document).forEach(function (target) {
      if (target._split) return;

      var root = unwrapSingleContainer(target);
      var nodes = Array.prototype.slice.call(root.children);
      if (!nodes.length) return;

      var hasRealHeading = nodes.some(isHeading);

      // Policy text pasted from a document often uses a bold paragraph as a
      // heading instead of a real heading tag. Only fall back to those when
      // there are no real headings to work with.
      var usePseudo = !hasRealHeading && nodes.some(isPseudoHeading);

      // Any heading level opens a section. Levels are not compared, because
      // merchants mix them freely (an h1 store name above h3 sections, say).
      function isHeadingLike(node) {
        return isHeading(node) || (usePseudo && isPseudoHeading(node));
      }

      target._split = true;

      var fragment = document.createDocumentFragment();
      var card = null;

      // Nothing to split on at all (a short refund policy, say). It still
      // becomes a card so every policy page looks the same.
      if (!hasRealHeading && !usePseudo) {
        card = document.createElement('section');
        card.className = 'policy-card rte';
        nodes.forEach(function (node) {
          card.appendChild(node);
        });
        fragment.appendChild(card);
        finalise(target, root, fragment);
        return;
      }

      nodes.forEach(function (node, index) {
        var previous = nodes[index - 1];

        // A heading directly after another heading is a subtitle, not a new
        // section, so it stays in the same card. Without this, a store name
        // above a section heading gets a card containing just one line.
        var starts =
          isHeadingLike(node) && !(previous && isHeadingLike(previous));

        if (starts || !card) {
          card = document.createElement('section');
          card.className = 'policy-card rte';
          // Anything before the first heading is the intro.
          if (!starts) card.classList.add('policy-card--intro');
          fragment.appendChild(card);
        }

        // Promote a bold paragraph to a real heading so it picks up the card
        // title styling and screen readers announce the structure.
        if (usePseudo && isPseudoHeading(node)) {
          var heading = document.createElement('h3');
          heading.textContent = node.textContent.trim();
          card.appendChild(heading);
          return;
        }

        card.appendChild(node);
      });

      finalise(target, root, fragment);
    });
  }

  /* ------------------------------------------------------------------------
     Header: hide on scroll down, reveal on scroll up
     ------------------------------------------------------------------------ */

  function initHeaderScroll() {
    var header = $('[data-header]');
    if (!header) return;

    if (header.getAttribute('data-hide-on-scroll') !== 'true') {
      // Still add the shadow once scrolled, just never hide the bar.
      window.addEventListener(
        'scroll',
        function () {
          header.classList.toggle('header--scrolled', window.scrollY > 10);
        },
        { passive: true }
      );
      return;
    }

    var lastY = window.scrollY;
    var ticking = false;
    // Ignore tiny jitters and don't hide until the header is fully passed.
    var DELTA = 6;

    function onScroll() {
      var y = window.scrollY;
      var threshold = header.offsetHeight;

      header.classList.toggle('header--scrolled', y > 10);

      if (Math.abs(y - lastY) < DELTA) {
        ticking = false;
        return;
      }

      if (y > lastY && y > threshold) {
        header.classList.add('header--hidden');
        closeSearchPanel();
      } else if (y < lastY) {
        header.classList.remove('header--hidden');
      }

      lastY = y;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(onScroll);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  /* ------------------------------------------------------------------------
     Header search panel
     ------------------------------------------------------------------------ */

  function closeSearchPanel() {
    var panel = $('[data-search-panel]');
    var toggle = $('[data-search-toggle]');
    var header = $('[data-header]');
    if (!panel) return;

    panel.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (header) header.classList.remove('header--pinned');
    closePredictiveSearch();
  }

  function toggleSearchPanel() {
    var panel = $('[data-search-panel]');
    var toggle = $('[data-search-toggle]');
    var header = $('[data-header]');
    if (!panel) return;

    var willOpen = !panel.classList.contains('is-open');

    panel.classList.toggle('is-open', willOpen);
    if (toggle) toggle.setAttribute('aria-expanded', String(willOpen));

    // Keep the bar on screen while the panel is open.
    if (header) header.classList.toggle('header--pinned', willOpen);

    if (willOpen) {
      var input = $('[data-search-input]', panel);
      if (input) {
        // Wait for the open transition so focus does not fight the animation.
        setTimeout(function () {
          input.focus();
        }, 120);
      }
    } else {
      closePredictiveSearch();
    }
  }

  on(document, 'click', '[data-search-toggle]', function (e) {
    e.preventDefault();
    toggleSearchPanel();
  });

  // Click outside the panel closes it.
  document.addEventListener('click', function (e) {
    var panel = $('[data-search-panel]');
    if (!panel || !panel.classList.contains('is-open')) return;
    if (e.target.closest('[data-search-panel]') || e.target.closest('[data-search-toggle]')) return;
    closeSearchPanel();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearchPanel();
  });

  /* ------------------------------------------------------------------------
     Share button
     ------------------------------------------------------------------------ */

  on(document, 'click', '[data-share]', function (e, button) {
    e.preventDefault();
    var url = button.getAttribute('data-share-url') || window.location.href;

    if (navigator.share) {
      navigator.share({ title: document.title, url: url }).catch(function () {});
      return;
    }

    navigator.clipboard.writeText(url).then(function () {
      var original = button.textContent;
      button.textContent = theme.strings.copied;
      setTimeout(function () {
        button.textContent = original;
      }, 2000);
    });
  });

  /* ------------------------------------------------------------------------
     Header dropdowns

     On a computer with a mouse the dropdowns open on hover, with a short
     grace period so the pointer can travel from the link into the menu.
     Touch and keyboard keep the native <details> tap / Enter behaviour.
     ------------------------------------------------------------------------ */

  var canHover = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;

  function hoverMode() {
    return !!(canHover && canHover.matches);
  }

  function closeNavDropdowns(except) {
    $$('.header__nav details[open]').forEach(function (item) {
      if (item !== except) item.open = false;
    });
  }

  function initNavDropdowns(scope) {
    $$('.header__nav details', scope || document).forEach(function (item) {
      if (item._navHover) return;
      item._navHover = true;

      var closeTimer = null;

      item.addEventListener('mouseenter', function () {
        if (!hoverMode()) return;
        clearTimeout(closeTimer);
        closeNavDropdowns(item);
        item.open = true;
      });

      item.addEventListener('mouseleave', function () {
        if (!hoverMode()) return;
        closeTimer = setTimeout(function () {
          item.open = false;
        }, 200);
      });

      // Hover has already opened it, so a mouse click would toggle it shut
      // under the pointer. Keep it open. Keyboard activation (detail 0) still
      // toggles as normal.
      var summary = $('summary', item);
      if (summary) {
        summary.addEventListener('click', function (e) {
          if (hoverMode() && e.detail > 0 && item.open) e.preventDefault();
        });
      }
    });
  }

  // Click anywhere else, or press Escape, to close an open dropdown.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.header__nav details')) closeNavDropdowns();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = $('.header__nav details[open]');
    if (!open) return;
    open.open = false;
    var summary = $('summary', open);
    if (summary) summary.focus();
  });

  /* ------------------------------------------------------------------------
     Init
     ------------------------------------------------------------------------ */

  function init(scope) {
    $$('[data-variant-picker]', scope || document).forEach(initVariantPicker);
    initAnimations();
    initHeaderScroll();
    initSlideshows(scope);
    initPolicyCards(scope);
    initTiltCards(scope);
    initCustomSelects(scope);
    initNavDropdowns(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Re-initialise when the theme editor swaps a section in.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('#CartDrawer')) openDrawer('CartDrawer');
  });

  // Expose a small API for other scripts and for the theme editor.
  window.BilashHaat = {
    openDrawer: openDrawer,
    closeDrawers: closeDrawers,
    refreshCart: refreshCartSections,
    addToCart: addToCart
  };
})();
